/** @format */
import { Component, Input, OnChanges, ViewEncapsulation } from '@angular/core';
import { PersonWithCourseUnitRealisationResponsibilityInfoType, PublicPerson } from 'common-typescript/types';
import * as _ from 'lodash-es';
import { take, tap } from 'rxjs/operators';
import { ComponentDowngradeMappings, DowngradedComponent, StaticMembers } from 'sis-common';
import { AppErrorHandler } from '../../error-handler/app-error-handler';
import { PersonNameService } from '../../service/person-name.service';
import { PublicPersonEntityService } from '../../service/public-person-entity.service';
import { sisuChain } from '../../util/utils';

@StaticMembers<DowngradedComponent>()
@Component({
    selector: 'sis-course-unit-realisation-responsibility-info',
    templateUrl: './course-unit-realisation-responsibility-info.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class CourseUnitRealisationResponsibilityInfoComponent implements OnChanges {
    static downgrade: ComponentDowngradeMappings = {
        moduleName: 'sis-components.courseUnitRealisationResponsibilityInfo',
        directiveName: 'sisCourseUnitRealisationResponsibilityInfo',
    };

    responsiblePersonsById: { [id: string]: PublicPerson } = {};
    sortedResponsibilityInfos: PersonWithCourseUnitRealisationResponsibilityInfoType[] = [];

    @Input() responsibilityInfos: PersonWithCourseUnitRealisationResponsibilityInfoType[];
    @Input() language: string;

    constructor(
        private appErrorHandler: AppErrorHandler,
        private personNameService: PersonNameService,
        private publicPersonEntityService: PublicPersonEntityService,
    ) {}

    ngOnChanges() {
        this.updateResponsiblePersons();
    }

    updateResponsiblePersons() {
        const responsiblePersonIds = sisuChain(this.responsibilityInfos).map('personId').uniq().compact().value();
        this.publicPersonEntityService.getByIds(responsiblePersonIds).pipe(
            take(1),
            tap(persons => {
                this.responsiblePersonsById = _.keyBy(persons, 'id');
                this.sortedResponsibilityInfos = sisuChain(this.responsibilityInfos)
                    .orderBy([
                        (info: any) => info.roleUrn === 'urn:code:course-unit-realisation-responsibility-info-type:administrative-person',
                        (info: any) => info.roleUrn === 'urn:code:course-unit-realisation-responsibility-info-type:contact-info',
                        (info: any) => info.roleUrn === 'urn:code:course-unit-realisation-responsibility-info-type:teacher',
                        (info: any) => !info.personId,
                        (info: any) => _.upperCase(this.personNameService.getFullName(_.get(this.responsiblePersonsById, info.personId))),
                    ])
                    .value();
            }),
            this.appErrorHandler.defaultErrorHandler(),
        );
    }
}
